import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { toggleShowTotal } from 'store/filters/filters-actions';
import { getTotalPriceUserPreference, TotalPriceSessionPreference, } from 'utils/total-price-session-utils';
import { useAllInPricingVariant, ALL_IN_PRICING_VARIANTS, } from 'hooks/use-all-in-pricing-variant';
export const useSyncTotalPriceToggleOnMount = () => {
    const totalPricePreferenceFromSession = getTotalPriceUserPreference();
    const variant = useAllInPricingVariant();
    const dispatch = useDispatch();
    const showTotal = useSelector((state) => state.filters.showTotal);
    const sessionShowTotal = totalPricePreferenceFromSession === TotalPriceSessionPreference.On;
    // Sync the show total state with the user preference from session
    useEffect(() => {
        if (totalPricePreferenceFromSession !==
            TotalPriceSessionPreference.NotSelected &&
            showTotal !== sessionShowTotal &&
            variant === ALL_IN_PRICING_VARIANTS.OFF) {
            dispatch(toggleShowTotal(sessionShowTotal));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Sync the show total state with the Ab test variant
    useEffect(() => {
        const variantShowTotal = variant === ALL_IN_PRICING_VARIANTS.ON_WITH_MARKETING ||
            variant === ALL_IN_PRICING_VARIANTS.ON_WITH_NO_MARKETING ||
            false;
        if (totalPricePreferenceFromSession ===
            TotalPriceSessionPreference.NotSelected &&
            variantShowTotal) {
            dispatch(toggleShowTotal(variantShowTotal));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
